module.exports = __webpack_public_path__ + "img/month_10_icon.d7766654.png";